import React from 'react';
import StyledSelect from '../../StyledSelect';
import EmojiPicker from '../../EmojiPicker';

const CategoryModals = ({
  categories,
  categoryAnalyticsData,
  categoryPdfs,
  deleteCategoryOption,
  editingCategory,
  exportCategoryData,
  formatDate,
  handleConfirmDeleteCategory,
  handleDeleteCategoryPdf,
  handleDownloadCategoryPdf,
  handleOpenPdfModal,
  handlePdfUpload,
  handleUpdateCategory,
  newCategory,
  pdfDescription,
  pdfUploadFile,
  pdfUploading,
  selectedAnalyticsCategory,
  selectedCategory,
  selectedCategoryForPdf,
  setDeleteCategoryOption,
  setEditingCategory,
  setNewCategory,
  setPdfDescription,
  setPdfUploadFile,
  setShowCategoryAnalytics,
  setShowDeleteCategory,
  setShowPdfListModal,
  setShowPdfModal,
  setTargetCategoryId,
  showCategoryAnalytics,
  showDeleteCategory,
  showPdfListModal,
  showPdfModal,
  targetCategoryId
}) => {
  return (
    <>
{showDeleteCategory && selectedCategory && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-lg">
              <h2 className="text-2xl font-bold text-slate-800 mb-6">
                Kategorie löschen
              </h2>
              <p className="text-slate-600 mb-6">
                Sind Sie sicher, dass Sie die Kategorie <strong>{selectedCategory.title}</strong> löschen möchten?
              </p>
              
              {selectedCategory.modules_count > 0 && (
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6">
                  <div className="flex items-center space-x-3">
                    <svg className="w-5 h-5 text-amber-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                    </svg>
                    <div>
                      <p className="text-amber-800 font-medium">Wichtiger Hinweis:</p>
                      <p className="text-amber-700 text-sm">
                        Diese Kategorie enthält {selectedCategory.modules_count} Module. Wählen Sie eine Option:
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {selectedCategory.modules_count > 0 && (
                <div className="space-y-4 mb-6">
                  <div className="space-y-3">
                    <label className="flex items-center space-x-3 p-3 border rounded-xl cursor-pointer hover:bg-slate-50 transition-colors">
                      <input
                        type="radio"
                        name="deleteOption"
                        value="move"
                        checked={deleteCategoryOption === 'move'}
                        onChange={(e) => setDeleteCategoryOption(e.target.value)}
                        className="text-blue-600 focus:ring-blue-500"
                      />
                      <div className="flex-1">
                        <span className="font-medium text-green-800">📦 Module verschieben (empfohlen)</span>
                        <p className="text-sm text-slate-600">Module in eine andere Kategorie verschieben, dann diese Kategorie löschen</p>
                      </div>
                    </label>
                    
                    {deleteCategoryOption === 'move' && (
                      <div className="ml-6 pl-3 border-l-2 border-green-200">
                        <label className="block text-sm font-medium text-slate-700 mb-2">
                          Zielkategorie wählen:
                        </label>
                        <StyledSelect
                          value={targetCategoryId}
                          onChange={(e) => setTargetCategoryId(e.target.value)}
                          variant="green"
                          required
                        >
                          <option value="">Kategorie auswählen...</option>
                          {categories
                            .filter(cat => cat.id !== selectedCategory.id)
                            .map(category => (
                              <option key={category.id} value={category.id}>
                                {category.title} ({category.modules_count} Module)
                              </option>
                            ))}
                        </StyledSelect>
                      </div>
                    )}
                    
                    <label className="flex items-center space-x-3 p-3 border rounded-xl cursor-pointer hover:bg-slate-50 transition-colors">
                      <input
                        type="radio"
                        name="deleteOption"
                        value="delete"
                        checked={deleteCategoryOption === 'delete'}
                        onChange={(e) => setDeleteCategoryOption(e.target.value)}
                        className="text-red-600 focus:ring-red-500"
                      />
                      <div className="flex-1">
                        <span className="font-medium text-red-800">🗑️ Module mitlöschen</span>
                        <p className="text-sm text-slate-600">Kategorie und alle {selectedCategory.modules_count} Module permanent löschen</p>
                      </div>
                    </label>
                  </div>
                </div>
              )}

              {selectedCategory.modules_count === 0 && (
                <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-6">
                  <div className="flex items-center space-x-3">
                    <svg className="w-5 h-5 text-green-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <p className="text-green-800 font-medium">Sicher zu löschen:</p>
                      <p className="text-green-700 text-sm">
                        Diese Kategorie ist leer und kann sicher gelöscht werden.
                      </p>
                    </div>
                  </div>
                </div>
              )}

              <p className="text-slate-600 mb-8 text-sm">
                Diese Aktion kann nicht rückgängig gemacht werden.
              </p>
              
              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => {
                    setShowDeleteCategory(false);
                    setDeleteCategoryOption('move');
                    setTargetCategoryId('');
                  }}
                  className="px-6 py-3 text-slate-700 bg-slate-200 hover:bg-slate-300 rounded-xl font-medium transition-colors"
                >
                  Abbrechen
                </button>
                <button
                  onClick={handleConfirmDeleteCategory}
                  disabled={selectedCategory.modules_count > 0 && deleteCategoryOption === 'move' && !targetCategoryId}
                  className={`px-6 py-3 rounded-xl font-medium transition-colors shadow-lg hover:shadow-xl ${
                    selectedCategory.modules_count > 0 && deleteCategoryOption === 'move' && !targetCategoryId
                      ? 'bg-slate-400 text-slate-600 cursor-not-allowed'
                      : deleteCategoryOption === 'delete' 
                        ? 'bg-red-600 hover:bg-red-700 text-white'
                        : 'bg-green-600 hover:bg-green-700 text-white'
                  }`}
                >
                  {selectedCategory.modules_count === 0 
                    ? 'Kategorie löschen'
                    : deleteCategoryOption === 'move' 
                      ? 'Module verschieben & löschen'
                      : 'Kategorie & Module löschen'
                  }
                </button>
              </div>
            </div>
          </div>
        )}

{showPdfModal && selectedCategoryForPdf && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">
              PDF zu "{selectedCategoryForPdf.title}" hinzufügen
            </h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">PDF-Datei</label>
                <input
                  type="file"
                  accept=".pdf"
                  onChange={(e) => setPdfUploadFile(e.target.files[0])}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Beschreibung (Optional)</label>
                <textarea
                  value={pdfDescription}
                  onChange={(e) => setPdfDescription(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="3"
                  placeholder="Beschreibung des PDF-Dokuments..."
                />
              </div>
            </div>
            <div className="flex justify-end space-x-4 mt-6">
              <button
                onClick={() => {
                  setShowPdfModal(false);
                  setPdfUploadFile(null);
                  setPdfDescription('');
                }}
                className="px-6 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
                disabled={pdfUploading}
              >
                Abbrechen
              </button>
              <button
                onClick={handlePdfUpload}
                disabled={!pdfUploadFile || pdfUploading}
                className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
              >
                {pdfUploading ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                    Wird hochgeladen...
                  </>
                ) : (
                  'PDF hochladen'
                )}
              </button>
            </div>
          </div>
        </div>
      )}

{showPdfListModal && selectedCategoryForPdf && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-800">
                📄 PDF-Materialien für "{selectedCategoryForPdf.title}"
              </h2>
              <button
                onClick={() => setShowPdfListModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="flex justify-between items-center mb-4">
              <div className="text-sm text-gray-600">
                {categoryPdfs[selectedCategoryForPdf.id]?.length || 0} PDF-Dokumente
              </div>
              <button
                onClick={() => {
                  setShowPdfListModal(false);
                  handleOpenPdfModal(selectedCategoryForPdf);
                }}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors"
              >
                + Neues PDF
              </button>
            </div>
            
            {/* PDF List */}
            {categoryPdfs[selectedCategoryForPdf.id]?.length > 0 ? (
              <div className="space-y-3">
                {categoryPdfs[selectedCategoryForPdf.id].map((pdf) => (
                  <div key={pdf.id} className="bg-gray-50 border border-gray-200 rounded-xl p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex-1 min-w-0">
                        <div className="font-medium text-gray-900">{pdf.filename}</div>
                        {pdf.description && (
                          <div className="text-gray-600 mt-1">{pdf.description}</div>
                        )}
                        <div className="text-sm text-gray-500 mt-2">
                          {new Date(pdf.upload_date).toLocaleDateString('de-DE')} • {Math.round(pdf.file_size / 1024)} KB
                        </div>
                      </div>
                      <div className="flex items-center space-x-2 ml-4">
                        <button
                          onClick={() => handleDownloadCategoryPdf(pdf.id, pdf.original_filename)}
                          className="text-green-600 hover:text-green-800 p-2 rounded hover:bg-green-50"
                          title="PDF herunterladen"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                        </button>
                        <button
                          onClick={() => handleDeleteCategoryPdf(pdf.id, selectedCategoryForPdf.id)}
                          className="text-red-600 hover:text-red-800 p-2 rounded hover:bg-red-50"
                          title="PDF löschen"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1-1H9a1 1 0 00-1 1v3M4 7h16" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <div className="text-gray-400 text-4xl mb-4">📄</div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">Noch keine PDF-Materialien</h3>
                <p className="text-gray-500 mb-4">
                  Laden Sie das erste PDF-Dokument für diese Kategorie hoch.
                </p>
                <button
                  onClick={() => {
                    setShowPdfListModal(false);
                    handleOpenPdfModal(selectedCategoryForPdf);
                  }}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors"
                >
                  Erstes PDF hochladen
                </button>
              </div>
            )}
          </div>
        </div>
      )}

{editingCategory && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-2xl">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">
              Kategorie bearbeiten
            </h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Titel</label>
                <input
                  type="text"
                  value={newCategory.title}
                  onChange={(e) => setNewCategory({...newCategory, title: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="z.B. Einführung in die Telekommunikation"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Beschreibung</label>
                <textarea
                  value={newCategory.description}
                  onChange={(e) => setNewCategory({...newCategory, description: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
                  rows="3"
                  placeholder="Beschreibung der Kategorie..."
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Icon (Emoji)</label>
                  <EmojiPicker
                    currentEmoji={newCategory.icon}
                    onSelect={(emoji) => setNewCategory({...newCategory, icon: emoji})}
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    Klicken Sie auf "Icon wählen" für eine große Auswahl
                  </p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Farbe</label>
                  <div className="flex items-center space-x-2">
                    <input
                      type="color"
                      value={newCategory.color}
                      onChange={(e) => setNewCategory({...newCategory, color: e.target.value})}
                      className="w-12 h-12 border border-gray-300 rounded-lg cursor-pointer"
                    />
                    <input
                      type="text"
                      value={newCategory.color}
                      onChange={(e) => setNewCategory({...newCategory, color: e.target.value})}
                      className="flex-1 px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
                      placeholder="#3B82F6"
                    />
                  </div>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Position</label>
                <input
                  type="number"
                  value={newCategory.order}
                  onChange={(e) => setNewCategory({...newCategory, order: parseInt(e.target.value) || 0})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
                  min="0"
                />
              </div>
              {/* Zielgruppe */}
              <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                <h4 className="text-sm font-semibold text-blue-900 mb-3">🎯 Zielgruppe festlegen</h4>
                <div className="space-y-2">
                  <label className="flex items-start space-x-3 p-3 border border-gray-200 rounded-lg hover:bg-blue-50 cursor-pointer bg-white">
                    <input
                      type="radio"
                      name="edit_target_role"
                      value="vertriebler"
                      checked={!newCategory.target_roles?.includes('teamleiter')}
                      onChange={() => setNewCategory({ ...newCategory, target_roles: ['vertriebler'], visibility_mode: 'cascade' })}
                      className="mt-0.5 text-blue-600 focus:ring-blue-500"
                    />
                    <div>
                      <span className="font-medium text-gray-900">💼 Vertriebler-Schulung</span>
                      <p className="text-xs text-gray-600 mt-1">
                        <strong>Pflicht für:</strong> Vertriebler &nbsp;·&nbsp; <strong>Mitsehen:</strong> Teamleiter, Vertriebsleiter, Admin
                      </p>
                    </div>
                  </label>
                  <label className="flex items-start space-x-3 p-3 border border-gray-200 rounded-lg hover:bg-blue-50 cursor-pointer bg-white">
                    <input
                      type="radio"
                      name="edit_target_role"
                      value="teamleiter"
                      checked={newCategory.target_roles?.includes('teamleiter') || false}
                      onChange={() => setNewCategory({ ...newCategory, target_roles: ['teamleiter'], visibility_mode: 'cascade' })}
                      className="mt-0.5 text-blue-600 focus:ring-blue-500"
                    />
                    <div>
                      <span className="font-medium text-gray-900">👥 Teamleiter-Schulung</span>
                      <p className="text-xs text-gray-600 mt-1">
                        <strong>Pflicht für:</strong> Teamleiter &nbsp;·&nbsp; <strong>Mitsehen:</strong> Vertriebsleiter, Admin
                      </p>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-4 mt-6">
              <button
                onClick={() => {
                  setEditingCategory(null);
                  setNewCategory({
                    title: '',
                    description: '',
                    color: '#3B82F6',
                    icon: '',
                    order: 0,
                    target_roles: [],
                    is_mandatory_for_roles: [],
                    visibility_mode: 'strict'
                  });
                }}
                className="px-6 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
              >
                Abbrechen
              </button>
              <button
                onClick={handleUpdateCategory}
                className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition-colors"
                disabled={!newCategory.title.trim()}
              >
                Aktualisieren
              </button>
            </div>
            
            {/* Live Preview for Edit Modal */}
            <div className="bg-gray-50 rounded-xl p-4">
              <h3 className="text-sm font-medium text-gray-700 mb-3">Live-Vorschau:</h3>
              <div className="bg-white rounded-xl shadow-lg p-4 max-w-md">
                <div className="flex items-center space-x-3">
                  <div 
                    className="w-12 h-12 rounded-2xl flex items-center justify-center text-white text-xl font-bold shadow-lg"
                    style={{ 
                      backgroundColor: newCategory.color,
                      boxShadow: `0 4px 15px -4px ${newCategory.color}40`
                    }}
                  >
                    {newCategory.icon || newCategory.title[0] || '?'}
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">
                      {newCategory.title || 'Kategorie-Titel'}
                    </h4>
                    <p className="text-sm text-gray-600 line-clamp-2">
                      {newCategory.description || 'Kategorie-Beschreibung'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      )}

{showCategoryAnalytics && selectedAnalyticsCategory && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-6xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-800">
                📊 Analytics für "{selectedAnalyticsCategory.title}"
              </h2>
              <button
                onClick={() => setShowCategoryAnalytics(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            {/* Analytics Overview Cards - Real Data */}
            {(() => {
              const d = categoryAnalyticsData[selectedAnalyticsCategory.id];
              return (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                    <div className="bg-blue-50 p-4 rounded-xl border border-blue-200">
                      <div className="text-2xl font-bold text-blue-600">{d ? d.active_users : '–'}</div>
                      <div className="text-sm text-blue-800">👥 Aktive Nutzer</div>
                    </div>
                    <div className="bg-green-50 p-4 rounded-xl border border-green-200">
                      <div className="text-2xl font-bold text-green-600">{d ? `${d.completion_rate}%` : '–'}</div>
                      <div className="text-sm text-green-800">✅ Abschlussrate</div>
                    </div>
                    <div className="bg-purple-50 p-4 rounded-xl border border-purple-200">
                      <div className="text-2xl font-bold text-purple-600">{d ? `${d.avg_time_minutes} Min` : '–'}</div>
                      <div className="text-sm text-purple-800">⏱️ Ø Bearbeitungszeit</div>
                    </div>
                    <div className="bg-orange-50 p-4 rounded-xl border border-orange-200">
                      <div className="text-2xl font-bold text-orange-600">{selectedAnalyticsCategory.modules_count}</div>
                      <div className="text-sm text-orange-800">📚 Module total</div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div className="bg-gray-50 p-6 rounded-xl">
                      <h3 className="text-lg font-semibold text-gray-900 mb-4">📈 Abschlüsse (letzte 8 Wochen)</h3>
                      {d && d.weekly_chart ? (
                        <div className="flex items-end gap-1 h-32">
                          {(() => {
                            const max = Math.max(...d.weekly_chart.map(w => w.count), 1);
                            return d.weekly_chart.map((w, i) => (
                              <div key={i} className="flex flex-col items-center flex-1 gap-1">
                                <span className="text-xs text-gray-500">{w.count > 0 ? w.count : ''}</span>
                                <div
                                  className="w-full rounded-t bg-indigo-500 transition-all"
                                  style={{ height: `${Math.max((w.count / max) * 88, w.count > 0 ? 4 : 0)}px` }}
                                  title={`${w.label}: ${w.count}`}
                                />
                                <span className="text-xs text-gray-400 truncate w-full text-center">{w.label}</span>
                              </div>
                            ));
                          })()}
                        </div>
                      ) : (
                        <div className="h-32 flex items-center justify-center text-gray-400 text-sm">Daten werden geladen…</div>
                      )}
                      <div className="mt-4 grid grid-cols-3 gap-4 text-sm">
                        <div className="text-center">
                          <div className="text-lg font-bold text-gray-900">{d ? d.week_completions : '–'}</div>
                          <div className="text-gray-600">Diese Woche</div>
                        </div>
                        <div className="text-center">
                          <div className="text-lg font-bold text-gray-900">{d ? d.month_completions : '–'}</div>
                          <div className="text-gray-600">Diesen Monat</div>
                        </div>
                        <div className="text-center">
                          <div className="text-lg font-bold text-gray-900">{d ? d.total_completions : '–'}</div>
                          <div className="text-gray-600">Gesamt</div>
                        </div>
                      </div>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-xl">
                      <h3 className="text-lg font-semibold text-gray-900 mb-4">📋 Kategorie-Details</h3>
                      <div className="space-y-3">
                        <div className="flex items-center space-x-2">
                          <div
                            className="w-6 h-6 rounded flex items-center justify-center text-white text-sm font-bold"
                            style={{ backgroundColor: selectedAnalyticsCategory.color }}
                          >
                            {selectedAnalyticsCategory.icon || selectedAnalyticsCategory.title[0]}
                          </div>
                          <span className="text-sm text-gray-600">Kategorie-Icon & Farbe</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <span className="text-2xl">📄</span>
                          <span className="text-sm text-gray-600">
                            {categoryPdfs[selectedAnalyticsCategory.id]?.length || 0} PDF-Materialien
                          </span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <span className="text-2xl">📊</span>
                          <span className="text-sm text-gray-600">Position: {selectedAnalyticsCategory.order}</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <span className="text-2xl">📅</span>
                          <span className="text-sm text-gray-600">
                            Erstellt: {formatDate(selectedAnalyticsCategory.created_at)}
                          </span>
                        </div>
                      </div>
                      <div className="mt-6">
                        <button
                          onClick={() => exportCategoryData(selectedAnalyticsCategory)}
                          className="w-full bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg font-medium transition-colors"
                        >
                          📥 Als CSV exportieren
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}
    </>
  );
};

export default CategoryModals;
